import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/apps/webui/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/apps/webui/src/components/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
